const RELOAD_GUARD_KEY = 'chunkLoadReloaded'

/**
 * One-shot reload when a ChunkLoadError happens (typically after a deploy invalidates
 * the chunks the current tab is referencing). The sessionStorage guard prevents
 * an infinite reload loop if reload itself fails the same way.
 */
export const handleChunkLoadReload = (): void => {
  try {
    if (sessionStorage.getItem(RELOAD_GUARD_KEY) === '1') return
    sessionStorage.setItem(RELOAD_GUARD_KEY, '1')
  } catch {
    // sessionStorage unavailable — bail without reloading to avoid loops
    return
  }
  window.location.reload()
}

export const clearChunkLoadGuard = (): void => {
  try {
    sessionStorage.removeItem(RELOAD_GUARD_KEY)
  } catch {
    // ignore
  }
}
